<template>
    <div class="summary" v-loading="deleteLoading" element-loading-text="删除中...">
        <div class="summary_bag">
            <!-- 产品类型切换 -->
            <div class="product-type-tabs">
                <el-tabs v-model="activeType" @tab-click="handleTypeChange">
                    <el-tab-pane label="单体" name="single"></el-tab-pane>
                    <el-tab-pane label="变体" name="variant"></el-tab-pane>
                </el-tabs>
            </div>
            <!-- 搜索区域 -->
            <div class="summary_Date">
                <div class="block">
                    <span class="demonstration">选择开始日期：</span>
                    <el-date-picker v-model="startTime" align="right" type="date" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="handleStartTimeChange">
                    </el-date-picker>
                </div>
                <div class="block">
                    <span class="demonstration">选择结束日期：</span>
                    <el-date-picker v-model="endTime" align="right" type="date" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="handleEndTimeChange">
                    </el-date-picker>
                </div>
                <div class="block">
                    <el-input clearable placeholder="请输入查询内容" v-model="searchStr" style="width: 360px;margin-top: 3px"
                        @input="searchStr = searchStr.replace(/\s+/g, '')">
                        <el-select v-model="searchType" slot="prepend" style="width: 100px" clearable>
                            <el-option label="SKU" value="sku"></el-option>
                            <el-option label="名称" value="name"></el-option>
                            <el-option label="型号" value="model"></el-option>
                            <el-option label="品牌" value="brand"></el-option>
                        </el-select>
                    </el-input>
                    <span class="demonstration search" @click="serach">搜索</span>
                    <span class="demonstration search" @click="reset">重置</span>
                </div>
            </div>
            <!-- 符合查询条件的产品共 -->
            <div class="summary_pagenum">
                <div class="summary_query">
                    符合查询条件的产品共
                    <span>{{ count }}</span>
                    件
                </div>
            </div>
            <!-- 批量操作区域 -->
            <div class="summary_content">
                <div class="summary_batch">
                    <div>
                        <span style="border-left:0">已选择产品{{ piece }}件</span>
                    </div>
                    <div>
                        <span @click="create">创建{{ activeType === 'single' ? '单体' : '变体' }}</span>
                        <span @click="del">批量删除</span>
                    </div>
                    <div>
                        <span @click="manageCategory">管理分类</span>
                    </div>
                </div>
                <!-- 表格区域 -->
                <div class="summary_list">
                    <el-table ref="multipleTable" :data="summarylist" style="width: 100%" v-loading="load_data"
                        element-loading-text="拼命加载中" border @selection-change="on_batch_select"
                        :header-cell-style="iscenter" stripe>
                        <el-table-column type="selection" width="50" align="center"></el-table-column>
                        <el-table-column label="图片" width="140" align="center">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="right">
                                    <img :src="getImage(scope.row)"
                                        class="prduct_img" alt />
                                    <div class="scope_img" slot="reference">
                                        <img :src="getImage(scope.row)"
                                            alt />
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column label="名称/SKU" align="center">
                            <template slot-scope="scope">
                                <p>{{ scope.row.name }}</p>
                                <p>{{ scope.row.sku }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="model" label="型号" width="180" align="center"></el-table-column>
                        <el-table-column prop="brand" label="品牌" width="180" align="center"></el-table-column>
                        <!-- 变体子体展示 -->
                        <el-table-column v-if="activeType === 'variant'" label="变体子体" width="200" align="center">
                            <template slot-scope="scope">
                                <el-dropdown v-if="scope.row.children && scope.row.children.length > 0" trigger="click">
                                    <span class="el-dropdown-link">
                                        查看子体({{ scope.row.children.length }})
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="variant-children-dropdown">
                                        <el-dropdown-item v-for="child in scope.row.children" :key="child.id">
                                            <div class="variant-child-item">
                                                <el-image 
                                                    v-if="child.imagesJson && child.imagesJson.mainImages && child.imagesJson.mainImages.length > 0" 
                                                    :src="child.imagesJson.mainImages[0]"
                                                    class="variant-child-image"
                                                    fit="cover">
                                                </el-image>
                                                <div class="variant-child-info">
                                                    <div class="variant-child-name">{{ child.name }}</div>
                                                    <div class="variant-child-sku">{{ child.sku }}</div>
                                                    <div class="variant-child-status">
                                                        <span :class="child.status === 1 ? 'green-box' : 'red-box'">
                                                            {{ child.status === 1 ? '在售' : '停售' }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <span v-else>暂无子体</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" width="100" align="center">
                            <template slot-scope="scope">
                                <div :class="scope.row.status === 1 ? 'green-box' : 'red-box'">
                                    <span>{{ scope.row.status === 1 ? '在售' : '停售' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="activeType === 'single'" prop="pairingStatus" label="Listing配对" width="100" align="center">
                            <template slot-scope="scope">
                                <div :class="scope.row.pairingStatus === 1 ? 'green-box' : 'red-box'">
                                    <span>{{ scope.row.pairingStatus === 1 ? '配对' : '未配对' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
                        <el-table-column prop="updateTime" label="更新时间" width="200" align="center"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="100" align="center">
                            <template slot-scope="scope">
                                <el-dropdown trigger="click" @command="(command) => handleCommand(command, scope.row)">
                                    <span class="el-dropdown-link">
                                        操作
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="edit">编辑</el-dropdown-item>
                                        <el-dropdown-item command="delete" divided>删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 分页 -->
            <div class="summary_pagenum_block">
                <div class="block">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage4" :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 创建弹框 -->
        <createInfoDialog v-model="dialogVisible" :type="activeType" :product-data="currentProduct"
            @submit="handleDialogSubmit" :selectSkuList="selectSkuList" :category-list="categoryList" :brand-list="brandList" @close="handleDialogClose" />
    </div>
</template>

<script>
import { ajaxPost, Baseurl, ajaxGet } from '@/api/api/api'
import createInfoDialog from './components/createInfoDialog.vue'

export default {
    name: 'ProductList',
    components: {
        createInfoDialog
    },
    data() {
        return {
            // 产品类型
            activeType: 'single',
            // 计数
            count: 0,
            piece: 0,
            // 搜索条件
            startTime: '',
            endTime: '',
            searchStr: '',
            searchType: 'sku',
            // 表格数据
            summarylist: [],
            load_data: false,
            // 分页
            currentPage4: 1,
            size: 10,
            // 表格样式
            iscenter: {
                textAlign: "center",
                background: "#f8f8f8",
                color: "#232323",
            },
            // 用户信息
            UserInfo: null,
            // 选中数据
            batch_select: [],
            dialogVisible: false,
            currentProduct: {},
            deleteLoading: false,
            categoryList: [],
            brandList: [],
            selectSkuList: [],
        }
    },
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('role'))
        await this.getCategoryList(); //获取树形结构
        await this.getBrandList(); //获取品牌列表
        this.getDate(1)
    },
    methods: {
        async getCategoryList(){
            const res = await ajaxPost(Baseurl + '/productCategory/selectProductCategory', { 
                companyId: this.userInfo.company_id,
            })
            if(res.data.code === 200){
                this.categoryList = res.data.data;
            }
        },
        async getBrandList(){
            const res = await ajaxGet(Baseurl + '/brandController/selectBrandList', { 
                companyId: this.userInfo.company_id,
            })
            if(res.data.code === 200){  
                this.brandList = res.data.data;
            }
        },
        manageCategory(){
            // 添加一个管理分类标签
            this.$router.push({
                path: "/box/SortAndAttribute",
            });
        },
        getImage(row) {
            if (row.imagesJson) {
                if (row.imagesJson.mainImages.length > 0) {
                    return row.imagesJson.mainImages[0]
                }
                return row.productImgUrl
            }
            return row.productImgUrl
        },
        // 处理开始时间变化
        handleStartTimeChange(val) {
            if (val) {
                this.startTime = val.split(' ')[0] + ' 00:00:00';
            }
        },
        // 处理结束时间变化
        handleEndTimeChange(val) {
            if (val) {
                this.endTime = val.split(' ')[0] + ' 23:59:59';
            }
        },
        // 加载表格数据
        async getDate(currentPage) {
            this.load_data = true;
            try {
                const params = {
                    status: 1,
                    companyId: this.userInfo.company_id,
                    // rid: this.userInfo.rid,
                    page: currentPage,
                    size: this.size,
                    searchType: this.searchType || "sku",
                    searchStr: this.searchStr || "",
                };
                // 根据 `activeType` 选择不同的接口
                const url =
                    this.activeType === "variant"
                        ? Baseurl + "productController/selectParentProductLibraryPage"
                        : Baseurl + "productController/selectChildProductLibraryPage";
                const res = await ajaxPost(url, params);
                if (res.data.code === 200) {
                    this.summarylist = res.data.data.list;
                    this.count = res.data.data.total;
                }
            } catch (error) {
                this.$message.error("获取数据失败！");
            } finally {
                this.load_data = false;
            }
        },

        // 类型切换
        handleTypeChange() {
            this.currentPage4 = 1
            this.getDate(1)
        },

        // 事件处理方法
        serach() {
            this.currentPage4 = 1
            this.getDate(1)
        },

        handleSizeChange(val) {
            this.size = val
            this.getDate(1)
        },
        reset(){
            this.startTime =  '',
            this.endTime =  '',
            this.searchStr =  '',
            this.searchType =  'sku'
            this.getDate(1)
        },
        handleCurrentChange(val) {
            this.currentPage4 = val
            this.getDate(val)
        },

        on_batch_select(val) {
            this.piece = val.length
            this.batch_select = val.map(item => ({
                id: item.listingId,
                productId: item.id
            }))
        },

        // 价格显示
        itemPrice(item) {
            return item.productPrice ? item.productPrice + (item.priceCurrency ? `(${item.priceCurrency})` : "") : ""
        },
        // 创建操作
        create() {
            this.getSelectSkuList();
            this.currentProduct = {
                type: this.activeType // 设置产品类型
            }
            this.dialogVisible = true;
        },
        // 创建弹窗关闭
        handleDialogClose() {
            this.dialogVisible = false;
            this.currentProduct = {};
            // 重置页码并刷新列表
            this.currentPage4 = 1;
            this.getDate(1);
        },
        // 删除操作
        del() {
            if (this.piece === 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.deleteLoading = true;
                // 转换数据格式
                const deleteData = {
                    ids: this.batch_select.map(item => item.productId)
                }
                ajaxPost(Baseurl + "productController/deleteProductLibrary", deleteData)
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getDate(1);
                        }
                    })
                    .finally(() => {
                        this.deleteLoading = false;
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
        },
        handleDelete(row) {
            this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.deleteLoading = true;
                // 转换数据格式
                const deleteData = {
                    ids: [row.id]
                }
                ajaxPost(Baseurl + "productController/deleteProductLibrary", deleteData)
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.getDate(1);
                        }
                    })
                    .finally(() => {
                        this.deleteLoading = false;
                    });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除",
                });
            });
        },
        // 编辑产品
        handleEdit(row, type) {
            this.getSelectSkuList(); //获取图库的图片列表
            this.currentProduct = {
                ...row,
                type: this.activeType, // 设置产品类型
                edit: type
            }
            this.dialogVisible = true
        },
        getSelectSkuList(){
            const params = {
                companyId: this.userInfo.company_id
            }
            ajaxPost(Baseurl + '/productController/selectSkusByCompanyId', params).then((res)=>{
                if(res.data.code === 200){
                    this.selectSkuList = res.data.data;
                }
            })
        },
        // 处理对话框提交
        async handleDialogSubmit(formData) {
            try {
                const url = this.currentProduct.edit
                    ? Baseurl + "productController/updateProductLibrary"
                    : Baseurl + "productController/createProductLibrary";
                const res = await ajaxPost(url, formData);
                if (res.data.code === 200) {
                    this.$message.success(this.currentProduct.edit ? '编辑成功!' : '创建成功!');
                    this.dialogVisible = false;
                    this.currentProduct = {};
                    // 重置页码并刷新列表
                    this.currentPage4 = 1;
                    await this.getDate(1);
                } else {
                    this.$message.error(res.data.data || (this.currentProduct.edit ? '编辑失败!' : '创建失败!'));
                }
            } catch (error) {
                console.error('操作失败:', error);
                this.$message.error(this.currentProduct.edit ? '编辑失败!' : '创建失败!');
            }
        },
        handleCommand(command, row) {
            switch (command) {
                case 'edit':
                    this.handleEdit(row, command)
                    break
                case 'delete':
                    this.handleDelete(row)
                    break
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.summary {
    width: 98%;
    padding-bottom: 72px;

    .summary_bag {
        width: 98%;
        margin: auto;

        .product-type-tabs {
            margin-bottom: 20px;
            background: #fff;
            padding: 0 20px;
            border-bottom: 1px solid #EBEEF5;

            :deep(.el-tabs__nav-wrap::after) {
                display: none;
            }

            :deep(.el-tabs__item) {
                font-size: 16px;
                padding: 0 20px;
                height: 40px;
                line-height: 40px;

                &.is-active {
                    color: #409EFF;
                    font-weight: bold;
                }
            }

            :deep(.el-tabs__active-bar) {
                height: 3px;
                background-color: #409EFF;
            }
        }

        .summary_Date {
            width: 100%;
            height: 50px;
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            background: #fff;

            .block {
                display: flex;
                align-items: center;
                margin-right: 20px;

                .demonstration {
                    margin-right: 10px;
                    color: #606266;
                }

                .el-date-picker {
                    width: 200px;
                }

                .el-input {
                    width: 360px;
                }

                .search {
                    padding: 4px 10px;
                    border-radius: 4px;
                    background: #2c8dff;
                    color: #fff;
                    margin-left: 10px;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        background: #409EFF;
                    }
                }
            }
        }

        .summary_pagenum {
            width: 100%;
            margin: 10px 0;
            overflow: hidden;
            background: #f5f5f5;
            padding: 0 20px;

            .summary_query {
                line-height: 32px;
                letter-spacing: 1px;
                color: #585858;

                span {
                    color: #2c8dff;
                    font-weight: bold;
                }
            }
        }

        .summary_content {
            width: 100%;
            border: 1px solid #EBEEF5;
            overflow: hidden;
            background: #fff;

            .summary_batch {
                width: 100%;
                overflow: hidden;
                border-bottom: 1px solid #EBEEF5;
                padding: 10px 20px;
                display: flex;
                align-items: center;

                div {
                    display: flex;
                    align-items: center;

                    span {
                        display: inline-block;
                        line-height: 20px;
                        margin: 0 10px;
                        padding: 0 10px;
                        color: #2c8dff;
                        border-left: 1px #2c8dff solid;
                        cursor: pointer;
                        transition: all 0.3s;

                        &:hover {
                            color: #409EFF;
                        }

                        &:first-child {
                            border-left: none;
                        }
                    }
                }
            }

            .summary_list {
                padding: 20px;

                .scope_img {
                    width: 55px;
                    height: 55px;
                    margin: 0 auto;
                    border: 1px solid #EBEEF5;
                    border-radius: 4px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }

        .summary_pagenum_block {
            width: 100%;
            padding: 20px;
            background: #fff;
            display: flex;
            justify-content: center;
        }
    }
}

.prduct_img {
    width: 500px;
    height: 500px;
    object-fit: cover;
    border-radius: 4px;
}

.green-box {
    color: #67c23a;
    font-weight: bold;
}

.red-box {
    color: #f56c6c;
    font-weight: bold;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    font-size: 12px;

    &:hover {
        color: #66b1ff;
    }
}

:deep(.el-dropdown-menu__item) {
    font-size: 12px;
    padding: 0 16px;
    min-width: 100px;

    &.is-disabled {
        color: #C0C4CC;
    }
}

.variant-children-dropdown {
    max-height: 400px;
    overflow-y: auto;
    
    .variant-child-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px;
        min-width: 300px;

        .variant-child-image {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #EBEEF5;
        }

        .variant-child-info {
            flex: 1;
            min-width: 0;

            .variant-child-name {
                font-size: 14px;
                color: #303133;
                margin-bottom: 4px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .variant-child-sku {
                font-size: 12px;
                color: #909399;
                margin-bottom: 4px;
            }

            .variant-child-status {
                font-size: 12px;
            }
        }
    }
}
</style>